// CANONICAL COPY (GH #7115). src/constants/obligations/obl-authority-contacts.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-authority-contacts',
  title: 'Maintain contact list with relevant authorities',
  description:
    'Verify and update the list of contacts with relevant authorities (regulators, law enforcement, emergency services).',
  category: 'governance',
  scfIds: ['SCF-GOV-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Authority contact list is published' },
    { type: 'document-within-sla', description: 'Contact list review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
